const config = require('../config/config.json') // 共通設定ファイル

export default {
    data () {
        return {
            config: config
        }
    }
}